'use client'

import ErrorBoundary from '@/components/ErrorBoundary'
import { DivineParsingOracle } from '@/components/divine-parsing-oracle'
import { ChunkedLanguageProvider } from '@/components/chunked-language-provider'

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <>
      {/* 🕊️ DIVINE PARSING ORACLE - Supreme Linguistic Authority */}
      <DivineParsingOracle
        initialNamespaces={["common", "navigation"]}
        initialLanguage="en"
      >
        <ChunkedLanguageProvider
          initialNamespaces={["common", "navigation", "hero"]}
          autoLoadRouteNamespaces={true}
        >
          <ErrorBoundary>
            {children}
          </ErrorBoundary>
        </ChunkedLanguageProvider>
      </DivineParsingOracle>
    </>
  )
}